import { M8PartnerClientsOnMonthClientDTO } from 'services/production/types';
import { normalizeM8CompanySize } from 'services/production/utils/normalizeM8CompanySize';
import {
  PartnerClientsTableItem,
  PartnerClientSubscription,
} from 'types/partnerClientsTable';
import { UnexpectedError } from 'utils/errors';
import { normalizeM8DateString } from './normalizeM8DateString';

export const normalizeM8PartnerClientsOnMonthClientDTO = (
  m8DTO: M8PartnerClientsOnMonthClientDTO
) => ({
  toPartnerClientsTableItem(): PartnerClientsTableItem {
    return {
      id: m8DTO.id,
      organization: m8DTO.organization,
      firstName: m8DTO.firstName,
      middleName: m8DTO.middleName,
      lastName: m8DTO.lastName,
      position: m8DTO.position,
      phone: m8DTO.phoneNumber,
      orgSize: m8DTO.companySize
        ? normalizeM8CompanySize(m8DTO.companySize).toOrgStaffCount()
        : 'small',
      licensesCount: m8DTO.licensesCount,
      income:
        m8DTO.income.description === 'FREE'
          ? null
          : {
              amount: m8DTO.income.amount,
              monthly: m8DTO.income.description === 'FULL_MONTH',
            },
      subscription: normalizeM8PartnerClientsOnMonthClientDTO(
        m8DTO
      ).toPartnerClientSubscription(),
      debitStatus:
        m8DTO.debitStatus !== null
          ? m8DTO.debitStatus === 'NOT_PAID'
            ? 'EXPIRED'
            : 'PAID'
          : null,
      willBeDeletedInDays: 0,
    };
  },
  toPartnerClientSubscription(): PartnerClientSubscription {
    const { subscription } = m8DTO;

    if (subscription.status === 'OPENED') {
      const activationDateISO = subscription.date
        ? normalizeM8DateString(subscription.date).toDate().toISOString()
        : null;
      return {
        status: 'ACTIVE',
        activationDateISO,
      };
    }

    if (subscription.status === 'CLOSED') {
      if (subscription.date === null) {
        throw new UnexpectedError();
      }

      const cancellationDateISO = normalizeM8DateString(subscription.date)
        .toDate()
        .toISOString();

      return {
        status: 'CANCELLED',
        cancellationDateISO,
      };
    }

    throw new UnexpectedError();
  },
});
